import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const ToggleSwitch = ({ isAnnual, setIsAnnual }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className='flex items-center justify-center space-x-4 rounded-2xl bg-white p-4 shadow-xl backdrop-blur-sm border border-gray-100'>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsAnnual(false)}
        className={`relative rounded-xl px-6 py-3 text-sm font-semibold transition-colors duration-200
          ${
            !isAnnual
              ? 'text-white shadow-md'
              : 'text-gray-600 hover:text-gray-900'
          }`}>
        Monthly
        {!isAnnual && (
          <motion.div
            layoutId='switchBackground'
            className='absolute inset-0 z-[-1] rounded-xl bg-gradient-to-r from-teal-500 to-teal-600'
            transition={{ type: 'spring', bounce: 0.3 }}
          />
        )}
      </motion.button>

      <div className='h-6 w-px bg-gray-200' />

      <div className='relative'>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setIsAnnual(true)}
          className={`relative rounded-xl px-6 py-3 text-sm font-semibold transition-colors duration-200
            ${
              isAnnual
                ? 'text-white shadow-md'
                : 'text-gray-600 hover:text-gray-900'
            }`}>
          Yearly
          {isAnnual && (
            <motion.div
              layoutId='switchBackground'
              className='absolute inset-0 z-[-1] rounded-xl bg-gradient-to-r from-teal-500 to-teal-600'
              transition={{ type: 'spring', bounce: 0.3 }}
            />
          )}
        </motion.button>

        {/* Enhanced discount badge */}
        <motion.div
          className='absolute -top-7 -right-3'
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: 0.9 }}
          transition={{ delay: 0.3 }}>
          {/* Dynamic sparkle ring */}
          {[...Array(8)].map((_, i) => (
            <motion.div
              key={i}
              className='absolute h-1.5 w-1.5 rounded-full bg-yellow-300'
              style={{
                top: '50%',
                left: '50%',
              }}
              animate={{
                x: `calc(cos(${i * 45 + 'deg'}) * 24px - 3px)`,
                y: `calc(sin(${i * 45 + 'deg'}) * 24px - 3px)`,
                opacity: [0.4, 1, 0.4],
                scale: [0.8, 1.2, 0.8],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                delay: i * 0.25,
                ease: 'easeInOut',
              }}
            />
          ))}

          {/* Lucide sparkles icon for extra flair */}
          <motion.div
            className='absolute -left-6 -top-2'
            animate={{
              rotate: [0, 15, -15, 0],
              scale: [1, 1.1, 0.9, 1],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut',
            }}>
            <Sparkles size={16} className='text-yellow-400' />
          </motion.div>

          {/* Main discount badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{
              opacity: 1,
              scale: 1,
              rotate: [-3, 3, -3],
            }}
            transition={{
              duration: 0.5,
              rotate: {
                duration: 6,
                repeat: Infinity,
                ease: 'easeInOut',
              },
            }}
            className='relative overflow-hidden rounded-lg bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400 px-3 py-1 text-xs font-bold text-white shadow-lg'>
            {/* Enhanced shine effect */}
            <motion.div
              className='absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-40'
              initial={{ x: '-100%' }}
              animate={{ x: '200%' }}
              transition={{
                repeat: Infinity,
                repeatDelay: 1.5,
                duration: 1,
                ease: 'easeInOut',
              }}
            />

            <motion.span
              animate={{
                scale: [1, 1.1, 1],
                textShadow: [
                  '0 0 0px rgba(255,255,255,0)',
                  '0 0 5px rgba(255,255,255,0.5)',
                  '0 0 0px rgba(255,255,255,0)',
                ],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse',
              }}
              className='inline-block font-mono tracking-wider'>
              SAVE 20%
            </motion.span>
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToggleSwitch;
